import { useEffect } from "react";
import { useState } from "react";
import { HTTP_REST_URLS } from "../config/urls";

const useApplicationDetails = () => {

    if(typeof window !== 'object')
    {
        return ({
            appData: null, 
            status : null,
            errorMessage : null
        })
    }

    const [appData, setAppData] = useState(null);
    const [status, setStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null)

    const getApplicationData = () => {
        
        const url = HTTP_REST_URLS.APPLICATION_DETAILS;

        fetch(url)
            .then((res) => (res.json()))
            .then((response) => {
                
                
                setAppData(response?.data)
                setStatus(response?.status)
                setErrorMessage(response?.message)
               
            })
            .catch((error) => {
                setAppData(null)
                setStatus(null)
                setErrorMessage(null)
            })

    }

    useEffect(() => {
        getApplicationData()
    }, [])

    return ({
        appData: appData,
        status : status,
        errorMessage : errorMessage
    });

};

export default useApplicationDetails;